export const API_CHANGE_ACCOUNT="gateway/app/disconnect";
export const API_ADD_ACCOUNT="gateway/app/connect";
export const API_GET_ACCOUNT="/gateway/identity/users/linked-accounts"